import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import * as React from "react";
import { css } from "styled-components";

export interface FooterStyles {
    page?: MobiusPageProps;
}

export const footerStyles: FooterStyles = {
    page: {
        css: css`
            max-width: 100% !important;
            padding: 0px !important;
            .footer-link-list {
                max-width: 100%;
                > div[class^="GridOffset"] {
                    -webkit-box-pack: justify;
                    justify-content: space-between;
                    margin: 0;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                width: 100%;
                            `,
                            css`
                                width: 100%;
                            `,
                            null,
                            null,
                            null,
                        ])}
                    >div[class^="GridItemStyle"]:first-child {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    padding: 0px;
                                `,
                                css`
                                    padding: 0px;
                                `,
                                null,
                                null,
                                null,
                            ])}
                    }
                    > div[class^="GridItemStyle"]:not(:first-child) {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    padding: 0px;
                                `,
                                css`
                                    padding: 0px;
                                `,
                                css`
                                    padding-left: 85px;
                                `,
                                null,
                                null,
                            ])}
                    }
                    > div[class^="GridItemStyle-sc"] {
                        &:first-of-type {
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(theme, [
                                    css`
                                        padding-top: 0;
                                    `,
                                    css`
                                        padding-top: 0;
                                    `,
                                    css`
                                        padding-top: 16px;
                                    `,
                                    null,
                                    null,
                                ])}
                        }
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    padding-top: 8px;
                                    padding-left: 0;
                                    padding-right: 0;
                                `,
                                css`
                                    padding-top: 8px;
                                    padding-left: 0;
                                    padding-right: 0;
                                `,
                                css`
                                    padding-left: 0;
                                    padding-right: 0;
                                    padding-top: 16px;
                                `,
                                null,
                                null,
                            ])}
                        > div[class^="Wrapper"] {
                            > div [class^="sc"] {
                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(theme, [
                                        null,
                                        null,
                                        css`
                                            justify-content: center;
                                        `,
                                        null,
                                        null,
                                    ])}
                            }
                        }
                    }
                }
            }
        `,
    },
};
const styles = footerStyles;

const Footer = ({ id }: PageProps) => (
    <Page as="footer" isFooter={true} {...styles.page}>
        <Zone contentId={id} zoneName="Content" />
    </Page>
);

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";
